import { useEffect, useState } from 'react';
import { getFormattedPreviewUrl } from '../utils/getFormattedPreviewUrl';
import { PREVIEW_DEVICES } from 'web-interactives-components/full-preview/constants/Preview';
const isValidPreviewDevice = value => Object.values(PREVIEW_DEVICES).includes(value);
export const usePreviewControls = ({
  basePreviewUrl,
  onDeviceChange,
  onUrlChange
}) => {
  const [previewDevice, setPreviewDevice] = useState(PREVIEW_DEVICES.DESKTOP);
  const [previewUrl, setPreviewUrl] = useState('');
  const [formattedPreviewUrl, setFormattedPreviewUrl] = useState(getFormattedPreviewUrl({
    basePreviewUrl,
    previewUrl
  }));
  useEffect(() => {
    setFormattedPreviewUrl(getFormattedPreviewUrl({
      basePreviewUrl,
      previewUrl
    }));
  }, [basePreviewUrl, previewUrl]);
  const handleDeviceChange = ({
    target: {
      value
    }
  }) => {
    if (!isValidPreviewDevice(value)) {
      return;
    }
    if (onDeviceChange) {
      onDeviceChange(value);
    }
    setPreviewDevice(value);
  };
  const handleUrlChange = ({
    target: {
      value
    }
  }) => {
    if (onUrlChange) {
      onUrlChange(value);
    }
    setPreviewUrl(value);
  };
  return {
    formattedPreviewUrl,
    handleDeviceChange,
    handleUrlChange,
    previewDevice,
    previewUrl
  };
};